import Projects from "@/components/pages/Community/Projects/Projects";

export default Projects;
